const SVG = ({ width = "14", height = "20", viewBox = "0 0 14 20" }) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.512573 7.51257L7 1.02515L13.4874 7.51257" stroke="#B69B64" />
    <path d="M0.512573 13.5126L7 7.02515L13.4874 13.5126" stroke="#B69B64" />
  </svg>
);

export default SVG;
